import { Appearance } from 'react-native';

import _ from 'lodash';

var colorSchemeInstance = (function () {
  var callbacks = [];
  let colorSchemeState = {
    colorScheme: Appearance.getColorScheme(),
  };

  const getCurrentColorScheme = () => {
    colorSchemeState = {
      ...colorSchemeState,
      colorScheme: Appearance.getColorScheme(),
    };
  };

  Appearance.addChangeListener(
    _.throttle(handleColorModeChange, 100, { leading: false, trailing: true }),
  );

  function handleColorModeChange({ colorScheme }) {
    colorSchemeState = { ...colorSchemeState, colorScheme: colorScheme };

    sendUpdateToSubscribers(colorSchemeState);
  }

  function sendUpdateToSubscribers(data) {
    callbacks.forEach(callback => callback(data));
  }

  return {
    subscribe: function (callback) {
      getCurrentColorScheme();
      callbacks.push(callback);
      callback(colorSchemeState);
    },
    unsubscribe: function (callback) {
      var index = callbacks.indexOf(callback);
      callbacks.splice(index, index);
    },
    getAllSubscribers: function () {
      return callbacks;
    },
  };
})();

export { colorSchemeInstance }; // eslint-disable-line import/prefer-default-export
